import * as React from 'react';

import BaseIcon from 'shared/components/icons/BaseIcon';
import { IconSize, CommonIconProps } from 'shared/entities/components/Icon';

const UploadIcon: React.FC<CommonIconProps> = ({
  svgProps,
  ...rest
}: CommonIconProps) => {
  return (
    <BaseIcon
      iconSize={IconSize.L}
      svgProps={{
        viewBox: '0 0 17 17',
        ...svgProps
      }}
      {...rest}
    >
      <path
        d="M12.5 4.99967L8.33333 0.833008M8.33333 0.833008L4.16666 4.99967M8.33333 0.833008L8.33333 10.833M0.833328 10.833L0.833328 11.833C0.833328 13.2331 0.833328 13.9332 1.10581 14.468C1.3455 14.9384 1.72795 15.3208 2.19835 15.5605C2.73313 15.833 3.4332 15.833 4.83333 15.833L11.8333 15.833C13.2335 15.833 13.9335 15.833 14.4683 15.5605C14.9387 15.3208 15.3212 14.9384 15.5608 14.468C15.8333 13.9332 15.8333 13.2331 15.8333 11.833L15.8333 10.833"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

export default UploadIcon;
